import * as React from 'react';
export default function SvgHamburger() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 64 64"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "hamburger_svg__a",
    cx: 60.21,
    cy: 56.856,
    r: 25.453,
    gradientTransform: "matrix(1.0721 0 0 .4054 -39.585 28.352)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9c42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.341,
    stopColor: "#f99840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#e88f39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#de8935"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hamburger_svg__a)",
    d: "M60.033 49.11C60.033 60.64 49.82 61 32 61c-17.821 0-28.033-.36-28.033-11.89 0-2.965 56.066-2.965 56.066 0z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hamburger_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 40.315,
    y1: 67.624,
    x2: 40.315,
    y2: 53.234,
    gradientTransform: "matrix(1.0114 0 0 .9808 -8.776 -5.326)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.218,
    stopColor: "#ff9c42",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#fc993f",
    stopOpacity: 0.215
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474,
    stopColor: "#f18f34",
    stopOpacity: 0.403
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.587,
    stopColor: "#df7e22",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#c66709",
    stopOpacity: 0.749
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#bd5e00",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hamburger_svg__b)",
    d: "M60.033 49.11C60.033 60.64 49.82 61 32 61c-17.821 0-28.033-.36-28.033-11.89 0-2.965 56.066-2.965 56.066 0z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hamburger_svg__c",
    cx: -13.079,
    cy: 89.584,
    r: 51.216,
    gradientTransform: "matrix(.9211 0 0 .1396 43.088 26.314)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    stopColor: "#572f1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#522c1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812,
    stopColor: "#452519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#402218"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hamburger_svg__c)",
    d: "M5.067 50.415c-2.942-2.248-2.9-10.518 1.141-12.025 7.69-2.871 41.75-3.875 52.313 1.274 3.842 1.872 3.476 12.752-2.915 11.439-1.227.466-4.105.659-5.783.425-3.545.797-8.982.879-10.688.425 0 0-3.849.632-7.073.021-4.99.572-8.06.07-8.06.07-5.121.669-9.323-.621-9.323-.621s-3.084.301-5.529-.291c-1.827-.029-2.802.262-4.083-.717z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#6B3924",
    d: "M40.295 42.796c-.672-2.83 3.572-.686 3.255 1.405-.152 1.001-2.132 3.318-3.255-1.405zM50.721 44.21c-.088-3.492 4.851-3.086 5.21-1.396.564 2.651-5.15 3.848-5.21 1.396zM10.202 44.228c-2.652-.244-3.031-4.139-1.082-4.079 4.615.138 2.011 4.166 1.082 4.079zM6.365 43.118c-1.207-.111-1.381-1.886-.49-1.859 2.099.063.914 1.898.49 1.859zM11.583 44.546c.171-1.533 1.569-1.629 1.484-.5-.196 2.674-1.546 1.036-1.484.5z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fill: "#170700",
    d: "M10.837 48.935c.17-1.533 1.565-1.629 1.483-.499-.195 2.672-1.543 1.036-1.483.499z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#6B3924",
    d: "M16.578 45.933c.17-1.532 1.566-1.629 1.483-.498-.197 2.673-1.546 1.035-1.483.498z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fill: "#170700",
    d: "M17.467 49.143c.171-1.532 2.814-1.493 2.732-.362-.198 2.672-2.792.898-2.732.362zM4.848 47.058c.171-1.532 1.567-1.629 1.483-.498-.195 2.673-1.545 1.035-1.483.498z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#6B3924",
    d: "M44.858 44.575c.219-2.026 2.104-2.138 2.001-.643-.246 3.539-2.079 1.354-2.001.643z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fill: "#170700",
    d: "M35.805 49.816c.219-2.026 2.104-2.138 2-.643-.245 3.539-2.079 1.354-2 .643z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#6B3924",
    d: "M38.308 45.667c.172-1.531 1.568-1.629 1.485-.498-.196 2.674-1.548 1.035-1.485.498zM57.366 43.571c.171-1.531 1.569-1.629 1.485-.498-.196 2.674-1.546 1.035-1.485.498z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fill: "#170700",
    d: "M53.563 48.294c.173-1.531 1.568-1.629 1.486-.498-.195 2.675-1.544 1.035-1.486.498z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#6B3924",
    d: "M30.206 45.608c-1.373-2.485 1.479-4.813 2.735-3.038 2.965 4.201-2.254 3.908-2.735 3.038zM16.23 42.72c.582 2.03-2.058 3.178-2.439 1.458-1.356-6.089 2.238-2.171 2.439-1.458z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fill: "#170700",
    d: "M29.759 48.401c.581 2.029-2.058 3.178-2.44 1.457-1.356-6.087 2.237-2.17 2.44-1.457z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#6B3924",
    d: "M37.289 44.412c1.033 3.013-3.031 1.574-3.14-1.003-.118-2.756 1.425-4.023 3.14 1.003z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fill: "#170700",
    d: "M47.235 49.626c-1.804 2.607-3.032 1.574-3.14-1.002-.119-2.758 4.947-1.607 3.14 1.002z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#6B3924",
    d: "M20.966 44.134c1.24 2.74-1.625 2.047-2.192-.43-.607-2.649.129-4.141 2.192.43z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fill: "#170700",
    d: "M8.91 50.525c.522.448-1.265-3.412-1.283-7.71-.011-2.721-2.478 4.475 1.283 7.71zM15.063 50.687c.499.181-1.262-2.04-1.358-5-.061-1.875-2.266 3.702 1.358 5zM23.964 51.484c.502.181-1.262-2.04-1.356-5-.061-1.875-2.265 3.703 1.356 5zM32.401 51.33c-.522.095 1.569-1.806 2.133-4.71.358-1.841 1.648 4.027-2.133 4.71zM39.261 51.719c-.54.091 1.561-2.038 2.04-5.396.3-2.126 1.861 4.748-2.04 5.396zM49.641 51.162c-.441.141.902-2.185.597-5.589-.192-2.155 2.605 4.581-.597 5.589zM55.562 50.726c-.576.193 1.278-2.646 1.073-6.674-.128-2.549 3.084 5.293-1.073 6.674z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fill: "#6B3924",
    d: "M49.497 44.577c-.687 3.039-2.283-.081-1.276-2.319 1.076-2.396 2.427-2.75 1.276 2.319z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hamburger_svg__d",
    cx: 10.303,
    cy: 36.438,
    r: 44.545,
    fx: 10.394,
    fy: 1.178,
    gradientTransform: "matrix(-.9903 .0164 -.0068 -.3369 42.298 37.967)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9b700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#f9b904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#fac110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.749,
    stopColor: "#fccd24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#ffdf3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffdf40"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hamburger_svg__d)",
    d: "M16.518 39.876c3.756 1.574 8.532 8.513 9.293 7.363 2.237-3.391 4.002-5.829 7.473-7.193 14.075-5.535 29.38 3.242 27.478.444-3.748-5.511-12.308-7.413-30.477-7.413-27.47 0-28.02 6.232-26.902 6.545 1.076.303 3.791-3.662 13.135.254z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hamburger_svg__e",
    cx: 34.56,
    cy: 15.233,
    r: 11.056,
    gradientTransform: "matrix(1.0335 -.0357 .0591 1.7149 -20.064 10)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3d3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239,
    stopColor: "#fb3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491,
    stopColor: "#ee2d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748,
    stopColor: "#d91a1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bd0000"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hamburger_svg__e)",
    d: "M34.069 36.091c-1.716 1.652-26.71 2.504-28.94 1.002-.929-.625-1.012-3.029-.129-3.717 1.339-1.043 28.112-1.697 28.943-1.002.828.695.906 2.967.126 3.717z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A80000",
    d: "M33.942 32.374C35.773 33.779 3.048 35.206 5 33.376c2.164-2.026 25.887-3.348 28.942-1.002z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hamburger_svg__f",
    cx: 73.349,
    cy: 96.49,
    r: 11.056,
    gradientTransform: "matrix(1.0078 .121 -.1982 1.5862 -11.514 -127.515)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3d3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239,
    stopColor: "#fb3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491,
    stopColor: "#ee2d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.748,
    stopColor: "#d91a1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bd0000"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hamburger_svg__f)",
    d: "M60.091 38.126c-1.91 1.262-26.281-1.674-28.222-3.387-.808-.715-.529-2.938.43-3.439 1.455-.76 27.52 2.623 28.224 3.387.7.763.438 2.865-.432 3.439z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A80000",
    d: "M60.522 34.687c1.566 1.566-30.39-1.994-28.224-3.387 2.4-1.543 25.608.774 28.224 3.387z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hamburger_svg__g",
    cx: 960.902,
    cy: -12.54,
    r: 10.691,
    gradientTransform: "matrix(-.8595 .1184 .1834 1.7036 845.865 -61.709)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa8ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#fda1e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    stopColor: "#f78de2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#ee6dd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    stopColor: "#e140c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#d107af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf00ac"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hamburger_svg__g)",
    d: "M3.23 33.606c1.642 1.375 22.427-1.498 24.068-3.313.156-.172.28-1.858-.038-2.071-1.248-.832-23.476 2.501-24.07 3.312-.185.256-.122 1.936.04 2.072z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A30088",
    d: "M3.19 31.535c-1.323 1.662 25.934-1.793 24.07-3.312-2.063-1.681-21.859.54-24.07 3.312z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hamburger_svg__h",
    cx: 971.047,
    cy: 90.747,
    r: 10.691,
    gradientTransform: "matrix(-.6834 -.0806 -.4578 1.6342 757.92 -38.314)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa8ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#fda1e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    stopColor: "#f78de2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#ee6dd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    stopColor: "#e140c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#d107af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf00ac"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hamburger_svg__h)",
    d: "M40.96 31.225c.747 1.653 17.279 3.588 19.139 2.256.177-.125.856-1.675.694-1.945-.642-1.055-18.412-2.884-19.139-2.257-.227.197-.768 1.784-.694 1.946z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A30088",
    d: "M41.654 29.28c-1.571 1.26 20.002 4.091 19.139 2.257-.954-2.032-16.519-4.358-19.139-2.257z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hamburger_svg__i",
    cx: 936.426,
    cy: 8.318,
    r: 10.691,
    gradientTransform: "matrix(-.8637 .0834 .1127 1.7096 843.161 -62.431)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa8ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117,
    stopColor: "#fda1e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.287,
    stopColor: "#f78de2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#ee6dd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    stopColor: "#e140c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#d107af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cf00ac"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hamburger_svg__i)",
    d: "M20.759 32.207c1.583 1.441 22.47-.587 24.187-2.334.163-.166.355-1.844.047-2.071-1.213-.881-23.558 1.547-24.188 2.334-.195.246-.201 1.928-.046 2.071z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A30088",
    d: "M20.805 30.136c-1.392 1.607 25.986-.742 24.188-2.334-1.992-1.763-21.864-.347-24.188 2.334z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hamburger_svg__j",
    gradientUnits: "userSpaceOnUse",
    x1: 1264.143,
    y1: -130.102,
    x2: 1278.016,
    y2: -130.102,
    gradientTransform: "matrix(-.8414 .1087 -.152 -1.1763 1058.826 -264.497)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#96cf33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#90c931"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529320"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hamburger_svg__j)",
    d: "M3.599 26.924c-1.854-3.246 1.062-3.234 2.42-1.875.309-2.051 3.182-3.638 4.47.162 1.701-.468 6.058-1.727 3.723 1.971.885 1.162 1.676 3.383-2.696 2.173.185 1.68-3.765 1.666-3.854-1.084-.882 1.526-5.432.592-4.063-1.347z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hamburger_svg__k",
    gradientUnits: "userSpaceOnUse",
    x1: 374.412,
    y1: -714.172,
    x2: 385.994,
    y2: -714.172,
    gradientTransform: "matrix(.0002 -.654 .9742 .0002 715.482 275.16)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#96cf33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#90c931"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529320"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hamburger_svg__k)",
    d: "M20.574 22.857c4.655-.966 4.268 1.173 2.245 2.002 2.753.476 4.548 2.771-.785 3.255.424 1.305 1.889 3.097-2.849.937-.472.945-4.211 2.041-3.943-.295-2.309-.067-.767-3.351 2.986-3.085-1.966-.83-.117-4.051 2.346-2.814z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hamburger_svg__l",
    gradientUnits: "userSpaceOnUse",
    x1: -96.743,
    y1: -536.962,
    x2: -86.603,
    y2: -536.962,
    gradientTransform: "matrix(.3662 -.5418 .8071 .5456 492.813 271.7)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#96cf33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#90c931"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529320"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hamburger_svg__l)",
    d: "M27.156 25.853c3.135.806 4.638 3.035 3.069 2.917 1.323 1.07-1.627 1.773-4.905.496-.42.865-1.401 2.641-3 .036-1.218-.203-3.209-.473-.409-1.571-1.276-.711.486-2.206 2.484-.961-.697-1.043 1.988-2.337 2.761-.917z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hamburger_svg__m",
    gradientUnits: "userSpaceOnUse",
    x1: 1239.291,
    y1: -155.477,
    x2: 1253.16,
    y2: -155.477,
    gradientTransform: "matrix(-.8414 .0964 -.1299 -.8922 1061.046 -232.145)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#96cf33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#90c931"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529320"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hamburger_svg__m)",
    d: "M27.162 26.959c-1.789-2.439 1.119-2.477 2.449-1.465.347-1.564 3.241-2.817 4.453.052 1.708-.384 6.076-1.41 3.678 1.44.86.869 1.607 2.545-2.728 1.696.151 1.273-3.79 1.327-3.827-.763-.907 1.175-5.429.536-4.025-.96z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hamburger_svg__n",
    gradientUnits: "userSpaceOnUse",
    x1: 672.572,
    y1: -807.315,
    x2: 684.214,
    y2: -807.315,
    gradientTransform: "matrix(-.2579 -.6693 .7827 -.3293 862.875 214.991)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#96cf33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#90c931"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529320"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hamburger_svg__n)",
    d: "M58.88 24.777c2.258-.246 3.045 1.474.695 2.393.834.807 3.029 2.858-1.389 2.36-1.071.699-3.792.916-3.346-1.633-1.764.432-6.807-2.768-3.879-3.362-1.805-.162 9.111-.745 7.919.242z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hamburger_svg__o",
    gradientUnits: "userSpaceOnUse",
    x1: 351.709,
    y1: -688.087,
    x2: 362.214,
    y2: -688.087,
    gradientTransform: "matrix(.0002 -.5803 .9742 .0002 715.482 234.386)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#96cf33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#90c931"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#529320"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hamburger_svg__o)",
    d: "M47.962 24.376c2.854.436 4.714 2.549-.815 2.995.438 1.202 2.012 4.088-2.899 2.103-1.754.468-5.362.944-3.081-1.871-2.393-.062-1.856-2.725 2.035-2.48-2.036-.762 6.856-1.511 4.76-.747z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hamburger_svg__p",
    cx: 114.952,
    cy: 16.051,
    r: 29.82,
    gradientTransform: "matrix(1.1289 0 0 .5447 -108.223 3.646)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.424,
    stopColor: "#ff9c42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#f5963e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#de8935"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hamburger_svg__p)",
    d: "M60.033 22.642c0 4.813-9.033 3-28.033 3-19.003 0-28.033 1.812-28.033-3C3.967 10.131 16.516 3.446 32 3.446c15.482 0 28.033 6.685 28.033 19.196z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hamburger_svg__q",
    gradientUnits: "userSpaceOnUse",
    x1: 128.565,
    y1: 16.023,
    x2: 128.565,
    y2: -4.389,
    gradientTransform: "matrix(1.1491 0 0 1.1038 -115.735 8.29)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#de6e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.044,
    stopColor: "#e77b13",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#f28a28",
    stopOpacity: 0.728
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.181,
    stopColor: "#f99437",
    stopOpacity: 0.546
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#fe9a3f",
    stopOpacity: 0.332
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#ff9c42",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#de6e00"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hamburger_svg__q)",
    d: "M60.033 22.642c0 4.813-9.033 3-28.033 3-19.003 0-28.033 1.812-28.033-3C3.967 10.131 16.516 3.446 32 3.446c15.482 0 28.033 6.685 28.033 19.196z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCF9E",
    d: "M33.332 3.401c.107.766-1.215.512-1.704.075.258-.414 1.607-.788 1.704-.075zM23.687 10.153c-.68.741-1.603-.532-1.596-1.296.646-.149 2.226.606 1.596 1.296z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFEDD1",
    d: "M32.871 8.536c-.459-.874 1.192-1.112 1.954-.79-.118.601-1.524 1.596-1.954.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCF9E",
    d: "M20.52 4.865c-.137-.813 1.491-.553 2.093-.092-.317.441-1.967.846-2.093.092zM15.358 12.982c-.883-.569.388-1.502 1.219-1.55.235.581-.398 2.076-1.219 1.55zM54.634 10.681c-.647.83-1.592-.352-1.607-1.125.632-.227 2.208.354 1.607 1.125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFEDD1",
    d: "M50.659 15.628c-.578.855-1.586-.336-1.654-1.125.606-.238 2.188.334 1.654 1.125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCF9E",
    d: "M11.824 8.921c-.678-.813.857-1.266 1.675-1.044.045.617-1.046 1.796-1.675 1.044z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFEDD1",
    d: "M37.888 14.651c-.825.287-.842-.877-.467-1.397.519.106 1.236 1.128.467 1.397zM42.593 5.638c.361-.731 1.34.139 1.501.767-.464.24-1.833-.088-1.501-.767z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCF9E",
    d: "M30.648 15.554c.845.199.146 1.254-.476 1.515-.353-.382-.307-1.698.476-1.515zM44.813 10.628c-.348.759-1.323-.077-1.487-.704.455-.265 1.811 0 1.487.704z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFEDD1",
    d: "M20.217 16.088c-.69-.5.391-1.206 1.069-1.21.164.483-.422 1.672-1.069 1.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCF9E",
    d: "M7.861 13.894c.098-.825 1.286-.301 1.641.25-.357.382-1.731.511-1.641-.25z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hamburger_svg__r",
    cx: 1182.998,
    cy: -247,
    r: 4.135,
    gradientTransform: "matrix(-1.0036 .0423 -.075 -.5669 1197.851 -162.306)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5da824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96cf33"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hamburger_svg__r)",
    d: "M26.497 29.365c.602 1.301 3.428.32 2.856-.643 1.846 1.218 3.778.004 2.588-.7 2.918-.801 1.081-1.565-.109-1.819-.814-1.283-2.581-.483-3.104.256-3.112-1.325-3.472.281-2.279 1.307-1.55-.198-2.98.698.048 1.599z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hamburger_svg__s",
    cx: -298.926,
    cy: 137.748,
    r: 5.85,
    gradientTransform: "matrix(.6574 .0187 -.0492 .5532 242.52 -43.205)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5da824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96cf33"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hamburger_svg__s)",
    d: "M43.509 27.356c.822 2.503-1.388 2.225-2.174 1.122-.603 1.445-3.067 2.317-3.363-.531-1.376.178-5.053 1.255-2.615-1.182-.465-.916-.546-2.01 2.553-.736.163-1.222 4.105-1.596 3.68.388.942-1.015 3.306-.325 1.919.939z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hamburger_svg__t",
    cx: -274.611,
    cy: 139.242,
    r: 6.07,
    gradientTransform: "matrix(.6574 .0187 -.0492 .5532 242.52 -43.205)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5da824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96cf33"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hamburger_svg__t)",
    d: "M59.382 29.045c.823 2.503-1.39 2.225-2.173 1.122-.604 1.445-3.069 2.317-3.362-.531-1.377.178-4.91.676-2.471-1.762-.464-.916-.666-2.585 2.435-1.311.161-1.223 3.157-.846 2.731 1.139.943-1.015 4.228.079 2.84 1.343z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hamburger_svg__u",
    cx: -179.889,
    cy: -463.053,
    r: 5.707,
    gradientTransform: "matrix(.3686 -.3081 .8123 .3102 491.62 116.112)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5da824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96cf33"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hamburger_svg__u)",
    d: "M51.34 25.848c3.135.714 1.832 1.693.262 1.59 1.323.949 1.455 3.011-1.823 1.878-.42.768-1.732 2.315-3.331.002-1.22-.18-3.152-.829-.353-1.804-1.276-.63.484-1.957 2.484-.853-.697-.926 1.988-2.074 2.761-.813z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hamburger_svg__v",
    cx: 1201.469,
    cy: -223.767,
    r: 4.29,
    gradientTransform: "matrix(-1.0036 .0477 -.075 -.6389 1197.851 -171.576)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5da824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96cf33"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hamburger_svg__v)",
    d: "M5.99 30.381c.602 1.467 3.53.963 2.962-.124 1.845 1.375 4.311.07 3.122-.724 2.919-.904.545-1.829-.645-2.113-1.284-2.704-2.581-.545-3.104.288-3.112-1.494-3.802-.075-2.607 1.082-1.551-.224-2.352 1.223.272 1.591z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "hamburger_svg__w",
    cx: -335.791,
    cy: 117.551,
    r: 6.6,
    gradientTransform: "matrix(.6574 .021 -.0331 .4194 240.627 -14.313)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5da824"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96cf33"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hamburger_svg__w)",
    d: "M21.187 27.536c.823 2.822-2.623 2.799-3.406 1.557-.604 1.626-3.068 2.61-3.363-.6-1.377.201-5.623 1.3-3.185-1.447-.464-1.033.057-2.088 3.156-.653.162-1.377 4.501-1.751 4.075.484.944-1.142 4.111-.765 2.723.659z"
  }));
}